// react
import {
    React,
    useState,
    useEffect,
    Fragment,
} from 'react';
// import { Image } from '@mantine/core';
import { Skeleton } from '@mantine/core';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { getData } from '../../services/fetch-service';
import CertifikataCheck from '../certifikata/CertifikataCheck';

function BlockSlideBox(props) {
    const { locale, location } = props;
    const [allLinks, setAllLinks] = useState([]);

    useEffect(() => {
        let locationMenuID;
        if (location === 'home') {
            locationMenuID = 5;
        } else if (location === 'slider') {
            locationMenuID = 11;
        } else if (location === 'aboutus') {
            locationMenuID = 10;
        } else {
            locationMenuID = null;
        }

        if (locationMenuID !== undefined) {
            getData(`Home/GetMenus?&Gjuha=${locale}&LocationMenuID=${locationMenuID}&ParentMenuID=0`).then((response) => {
                setAllLinks(response.data);
            });
        }
    }, [locale, location]);

    let ImageLoading = true;
    let NameLoading = true;

    const linksList = allLinks.map((item, index) => {
        const path = process.env.REACT_APP_FILESPATH;
        const image = `${path}${item.media[0]?.mediaEmri}${item.media[0]?.mediaEx}`;

        if (image) {
            ImageLoading = false;
        }

        if (item.pageName) {
            NameLoading = false;
        }

        return (
            <li key={index}>
                {item.hasChild === true ? (
                    <div className="slider-box-link slider-box-link-childs">
                        <img src={image} alt="box-ballin" />
                        <div className="link-childs-list">
                            <div className="and-devider">
                                <Link to={item.url}>
                                    {item.pageName}
                                </Link>
                                <p><FormattedMessage id="and" defaultMessage="dhe" /></p>
                            </div>

                            {item.submenu.map((submenu, key) => {
                                return (
                                    <Link key={key} to={submenu.url}>
                                        {submenu.pageName}
                                    </Link>
                                );
                            })}
                        </div>

                    </div>
                )
                    : (
                        <Fragment>
                            {
                                item.otherSource === false ? (
                                    <Link className="slider-box-link" to={item.url}>
                                        {ImageLoading ? (
                                            <Skeleton height={64} width={64} circle />
                                        ) : (
                                            <img src={image} alt="box-ballin" />
                                        )}
                                        {NameLoading ? (
                                            <div className="skeleton-title">
                                                <Skeleton className="skeleton-bar" height={8} radius="xl" />
                                                <Skeleton width="70%" className="skeleton-bar" height={8} radius="xl" />
                                            </div>
                                        ) : (
                                            <Fragment>
                                                {item.pageName}
                                            </Fragment>
                                        )}
                                    </Link>
                                ) : (
                                    <a className="slider-box-link" target={item.targeti} href={item.url}>
                                        {ImageLoading ? (
                                            <Skeleton height={64} width={64} circle />
                                        ) : (
                                            <img src={image} alt="box-ballin" />
                                        )}
                                        {NameLoading ? (
                                            <div className="skeleton-title">
                                                <Skeleton className="skeleton-bar" height={8} radius="xl" />
                                                <Skeleton width="70%" className="skeleton-bar" height={8} radius="xl" />
                                            </div>
                                        ) : (
                                            <Fragment>
                                                {item.pageName}
                                            </Fragment>
                                        )}
                                    </a>
                                )
                            }
                        </Fragment>
                    )}
            </li>
        );
    });

    return (
        <Fragment>
            <div className={`block-slideshow__slide-content boxsection-home box-${location}`}>
                <ul className="slider-boxes">
                    {linksList}
                    {location === 'home' && <CertifikataCheck />}
                </ul>
            </div>
        </Fragment>
    );
}

BlockSlideBox.propTypes = {
    location: PropTypes.oneOf(['home', 'slider', 'aboutus']),
    // locale: PropTypes.string,
};

BlockSlideBox.defaultProps = {
    location: 'home',
};

const mapStateToProps = (state) => ({
    locale: state.locale,
});

export default connect(mapStateToProps)(BlockSlideBox);
